import React from "react";

// import "./App.css";

import Navbar from "./navbar";
import Routes from "./routes";

const App = () => {
  return (
    <div>
      <Navbar />
      <Routes />
    </div>
  );
};

export default App;
